import _ from 'lodash';
import timm from 'timm';

import { Types } from 'app/actions/page-bracket-game';
import utils from 'app/reducers/utils';

const initialState = {
  loadPending: false,
  bracketGameId: null,
};

const reducer = utils.createReducer(initialState, {

  [`${Types.LOAD}_PENDING`]: (state, {bracketGameId}) => {
    return {...state,
      loadPending: true,
      bracketGameId,
    };
  },
  [`${Types.LOAD}_RESOLVED`]: (state, {bracketGameId}) => {
    if (bracketGameId !== state.bracketGameId) return state;
    return {...state,
      loadPending: false,
    };
  },
  [`${Types.LOAD}_REJECTED`]: (state, {bracketGameId}) => {
    if (bracketGameId !== state.bracketGameId) return state;
    return {...state,
      loadPending: false,
    };
  },

});

export default reducer;
